import { useState } from 'react';
import { UseTableCellProps } from 'react-table';
import { Grid, Menu, MenuItem, IconButton } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import { useUserPermissions } from 'shared/hooks';
import { PERMISSIONS } from 'shared/constants';
import { useContractInventoryFormState } from 'shared/contexts/contract-inventory-form-context';
import { CustomerContractInventoryGridItem } from 'shared/types';
import { useGetDraftContract } from 'shared/queries';
import { compareDates } from 'shared/utility';

export const CustomerContractContextMenuColumn = (props: UseTableCellProps<CustomerContractInventoryGridItem>) => {
  const {
    row: {
      original: { id, status, endDate, deletedAt },
    },
  } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const {
    toggleContractStatusDialog,
    setContractIdForToggleStatus,
    toggleContractDeleteDialog,
    setContractIdToDelete,
  } = useContractInventoryFormState();
  const userPermissions = useUserPermissions();
  const { draftContract } = useGetDraftContract(id);
  const hasEditContractPermissions = userPermissions.includes(PERMISSIONS['contract.edit']);
  const isContractExpired = compareDates(new Date(endDate), new Date()) === 1;
  const isContractDeleted = Boolean(deletedAt);
  const canStatusBeToggled = (status === 'active' || status === 'inactive') && !isContractExpired;
  const isDraft = draftContract !== undefined;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleContractStatusClick = () => {
    setContractIdForToggleStatus(id);
    toggleContractStatusDialog();
    setAnchorEl(null);
  };

  const handleContractDeleteClick = () => {
    setContractIdToDelete(id);
    toggleContractDeleteDialog();
    setAnchorEl(null);
  };

  return (
    <Grid>
      <IconButton onClick={handleClick}>
        <MoreVert />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          onClick={handleContractStatusClick}
          disabled={!hasEditContractPermissions || !canStatusBeToggled}
          title={hasEditContractPermissions ? '' : 'You do not have permission to perform this action.'}
        >
          {status === 'inactive' ? ' Mark Active' : 'Mark Inactive'}
        </MenuItem>
        <MenuItem onClick={handleContractDeleteClick} disabled={isDraft}>
          {isContractDeleted ? ' Restore' : 'Delete'}
        </MenuItem>
      </Menu>
    </Grid>
  );
};
